import KeenSlider from 'keen-slider';
import 'keen-slider/keen-slider.min.css';
import debounce from 'debounce';

// for the slider inside the prefooter block
document.addEventListener('DOMContentLoaded', function () {
  class BlockMetiers extends HTMLElement {
    constructor() {
      super();
      // elements
      this.keenSliders = [];
      this.slider = this.querySelector('.keen-slider');
      this.listSelector = '.js-metiers__list';
      this.prevSelector = '.js-metiers__prev';
      this.nextSelector = '.js-metiers__next';
    }
    connectedCallback() {
      // bindings
      // events
      this.onLoad();
    }
    disconnectedCallback() {
      this.keenSliders.forEach(slider => {
        if (slider.destroy) slider.destroy();
      });
    }
    onLoad() {
      this.initSliders();
    }
    initSliders() {
      if (!this.slider) return;
      this.initSlider(this.slider);
    }
    initSlider(el, index) {
      if (!el) return;
      this.keenSliders[index] = new KeenSlider(el, {
        slides: {
          perView: 1.15,
          spacing: 20
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.15,
              spacing: 20
            }
          },
          '(min-width: 992px)': {
            slides: {
              perView: 4.15,
              spacing: 20
            }
          }
        }
      }, [slider => {
        const next = slider.container.closest(this.listSelector).querySelector(this.nextSelector);
        const prev = slider.container.closest(this.listSelector).querySelector(this.prevSelector);
        const refreshArrows = slider => {
          const details = slider.track.details;
          const current = details?.rel ?? 0;
          prev?.removeAttribute('disabled');
          next?.removeAttribute('disabled');
          if (current === 0) {
            prev?.setAttribute('disabled', 'disabled');
          }
          if (current >= details.maxIdx) {
            next?.setAttribute('disabled', 'disabled');
          }
        };
        slider.on('created', () => {
          slider.container?.classList.add('is-ready');
          refreshArrows(slider);
          prev?.addEventListener('click', () => {
            slider.prev();
          });
          next?.addEventListener('click', () => {
            slider.next();
          });
        });
        slider.on('slideChanged', () => {
          refreshArrows(slider);
        });
      }]);
    }
  }
  customElements.define('block-metiers', BlockMetiers);
});